import { render, staticRenderFns } from "./rainfall-detail.vue?vue&type=template&id=c3807262&scoped=true"
import script from "./rainfall-detail.vue?vue&type=script&lang=js"
export * from "./rainfall-detail.vue?vue&type=script&lang=js"
import style0 from "./rainfall-detail.vue?vue&type=style&index=0&id=c3807262&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3807262",
  null
  
)

export default component.exports